/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'video': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M1.829 2H18.17c.274 0 .496.22.496.492v15.266a.494.494 0 01-.496.492H1.83a.494.494 0 01-.496-.492V2.492c0-.272.222-.492.496-.492zm.495 13.296v1.97h1.98v-1.97h-1.98zm0-.985h1.98v-1.97h-1.98v1.97zm0-2.955h1.98v-1.97h-1.98v1.97zm0-2.954h1.98v-1.97h-1.98v1.97zm0-2.955h1.98V2.985h-1.98v2.462zm2.971-2.462v6.894h9.41V2.985h-9.41zm10.4 0v2.462h1.981V2.985h-1.98zm1.981 3.447h-1.98v1.97h1.98v-1.97zm0 2.954h-1.98v1.97h1.98v-1.97zm0 2.955h-1.98v1.97h1.98v-1.97zm0 2.955h-1.98v1.97h1.98v-1.97zm-2.971 1.97v-6.402h-9.41v6.401h9.41z" _fill="#1D3861"/>'
  }
})
